import FlowNode from './flowNode.js';
import getGdprOptions from './getGdprOptions';

export default class InputNode extends FlowNode {
  constructor(id, data) {
    super(id, data);
    this.title = data.title;
    this.tagline = data.tagline;
    this.partials = data.partials;
    this.continueButtonLabel = data.nextButtonLabel;
    this.template = data.template;
    this.variables = data.variables;
    Object.assign(this.options, getGdprOptions());
  }
}
